import type { HeadingBlock as HeadingBlockType } from '@/shared/types/blocks';

const headingStyles = {
  1: 'title-small-b text-black', // 20px Bold, lh 1.2 - 페이지/리포트 제목 (Figma 기준)
  2: 'title-small-b text-black', // 20px Bold, lh 1.2 - 섹션 제목
  3: 'title-small-b text-black', // 20px Bold, lh 1.2 - 아티클 섹션 제목 (Figma: Title/Small B)
  4: 'label-medium-b text-black', // 16px Bold - 카드 내 소제목
  5: 'label-small-b text-black', // 14px Bold - 라벨/캡션
} as const;

/**
 * HeadingBlock - 제목
 *
 * Typography 토큰 사용으로 Figma 디자인 시스템과 일관성 유지
 */
export function HeadingBlock({ level, text }: Omit<HeadingBlockType, 'type' | 'id'>) {
  const Tag = `h${level}` as const;
  const className = headingStyles[level] || headingStyles[4];

  return <Tag className={className}>{text}</Tag>;
}
